import { ProgramStat } from '../../../data/programs';

type Props = ProgramStat;

/**
 * One cell of the hero stats strip: marketing's copy above the name of what
 * it is stating.
 *
 * Uniform across all four cells, because the values are free text and there
 * is no longer a numeric one to single out - "6" and "Included with All
 * Access" land in the same slot and have to sit at the same size.
 *
 * The divider between cells belongs to the strip, not here: cells drop out
 * when a program has no copy for them, and only the container knows which
 * one ended up first.
 */
export const DetailStat = ({ label, value }: Props) => (
  <div className="flex flex-col items-center justify-center px-8 text-center first:pl-0">
    <span className="text-lg font-semibold text-white">{label}</span>
    <span className="text-base text-white">{value}</span>
  </div>
);
